 /* eslint-disable */

import { defineStore } from 'pinia';
import { useLanguagesStore } from './languages';
import { useCurrenciesStore } from './currencies';
import { useRegisterStore } from './register';

import { useCountriesStore } from './countries';
import { useTimezonesStore } from './timezones';
import { useGeneralStore } from './general';
import { useRegistrationDocumentTypesStore } from './registration_documents_types';
import { useMenuStore } from './menus';
import { BetSlip } from './BetSlip';
import { usePromotionsStore } from '@/stores/promotions';
import { useAccaBoostStore } from './acca_boost';
import { useVirtualCourtStore } from './virtual_court';
import { usePlatformConfigurationStore } from './platform_configuration';
import { useBestlineVideoStore } from './bestline_video';
import { useThemeStore } from './themes';
import _ from 'lodash';

export const useInitializeStore = defineStore('initialize', {
	state: () => ({
		server_timestamp: 0,
		screen_width: window.innerWidth,
		product_settings: null,
		sport_ids: [],
		pixel_support: false,
		casino_pages: [],
		pixel_pages: [],
		taboola_fired_events: {},
		landing_page: null,
	}),
	getters: {
		screenWidth(state) {
			return state.screen_width;
		},
		landingPage(state) {
			return state.landing_page;
		},
		isMobile() {
			let is_mobile = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

			if (is_mobile) {
				// Code for mobile devices
				return true;
			}

			return false;
		},
		// see if the user is using an iPhone or iPod
		isIphoneOrIpod() {
			const userAgent = window.navigator.userAgent;
			const iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i);
			const webkit = !!userAgent.match(/WebKit/i);
			const iOSSafari = iOS && webkit && !userAgent.match(/CriOS/i);
			if (iOSSafari) return true;
			else return false;
		},
		isAppleMobile() {
			const user_agent = window.navigator.userAgent;
			const platform = window.navigator.platform;
			const is_ios_device = /iPhone|iPod|iPad/.test(user_agent);
			const is_modern_ipad = platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

			return is_ios_device || is_modern_ipad;
		},
		betcomCourtEnabled() {
			if (process.env.VUE_APP_VIRTUAL_COURT_BETCOM_ENABLED) return true;
			return false;
		},
		isSportsbookEnabled(state) {
			let product = _.find(state.product_settings, {'product': 'sportsbook'});
			if (product.enabled == true) return true;

			return false;
		},
		isCasinoEnabled(state) {
			let product = _.find(state.product_settings, {'product': 'casino'});
			if (product.enabled == true) return true;

			return false;
		},
		isLiveCasinoEnabled(state) {
			let product = _.find(state.product_settings, {'product': 'live-casino'});
			if (product.enabled == true) return true;

			return false;
		}
	},
	actions: {
		getVersionData() {
			return global.axios.get(process.env.VUE_APP_API_URL + '/initialize/mobile-version/info').then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error);
			});
		},
		initialize() {
			return global.axios.get(process.env.VUE_APP_API_URL + '/initialize').then((response) => {
				useLanguagesStore().setLanguages(response.data.data.languages);
				useCurrenciesStore().setCurrencies(response.data.data.currencies);
				useCountriesStore().setCountries(response.data.data.countries);
				useCountriesStore().setResolvedRegion(response.data.data.resolved_region);
				useTimezonesStore().setTimezones(response.data.data.timezones);
				useGeneralStore().setGeneral(response.data.data.general);
				useRegisterStore().setEnabledRegistrationFields(response.data.data.registration_fields);
				BetSlip().setBetslipTax(response.data.data.betslip_tax);
				useMenuStore().setFooterDescriptions(response.data.data.footer_descriptions);
				useRegistrationDocumentTypesStore().setRegistrationDocumentType(response.data.data.registration_document_types);
				this.product_settings = response.data.data.product_settings;
				useAccaBoostStore().setAccaBoostScale(response.data.data.acca_boost_settings);
				useAccaBoostStore().setAvailableMarkets(response.data.data.acca_boost_enabled_markets);
				useVirtualCourtStore().setToken(response.data.data.virtual_court_token);
				usePlatformConfigurationStore().setPlatformConfiguration(response.data.data.platform_configuration);
				usePlatformConfigurationStore().setLiveChat(response.data.data.live_chat);
				useThemeStore().setThemes(response.data.data.themes);

				useBestlineVideoStore().setStreamingUrls(response.data.data.streaming_urls)
				this.sport_ids = response.data.data.sport_ids;
				this.casino_pages = response.data.data.casino_pages;
				this.pixel_support = response.data.data.pixel_support;
				this.pixel_pages = response.data.data.pixel_pages;
				this.landing_page = response.data.data.landing_page;

				this.setAppleWebAppTitle();

				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		fireTaboolaEventOnce(event_name, pixel_id = process.env.VUE_APP_TABOOLA_PIXEL) {
			if (this.taboola_fired_events[event_name] === true) return;

			if (!window._tfa) return;

			this.taboola_fired_events[event_name] = true;

			window._tfa = window._tfa || [];
			window._tfa.push({
				notify: "event",
				name: event_name,
				id: Number(pixel_id),
			});
		},
		setAppleWebAppTitle() {
			let meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
			if (!meta) {
				meta = document.createElement('meta');
				meta.setAttribute('name', 'apple-mobile-web-app-title');
				document.head.appendChild(meta);
			}
			meta.setAttribute('content', useGeneralStore().general.site_name);
		},
		setServerTimestamp(data) {
			this.server_timestamp = data;
		},
		tickServerTimestamp() {
			this.server_timestamp++;
		},
		updateScreenWidth() {
			this.screen_width = window.innerWidth;
		},
		setProductSettings(data) {
			this.product_settings = data;
		},
		addMenuPixel() {
			!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
				n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
				document,'script','https://connect.facebook.net/en_US/fbevents.js');

			// Initialize and track
			fbq('init', process.env.VUE_APP_FACEBOOK_PIXEL);
			fbq('track', 'PageView');

			const noscript = document.createElement('noscript');
			noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/"`;
			document.body.appendChild(noscript);
		},
		removeMenuPixel() {
			try {
				fbq('set', 'autoConfig', false, process.env.VUE_APP_FACEBOOK_PIXEL);
			} catch (error) {
				//
			}
		},
		shouldTrackPixel(path) {
			if (!this.pixel_support) return false;
			if (!this.pixel_pages || this.pixel_pages.length === 0) return false;
			if(path == '/' && this.pixel_pages.includes('/landing')) return true;

			return this.pixel_pages.some(url => path.startsWith(url));
		}
	},
})